import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import vueFilters from "vue2-filters";
import VueMoment from "vue-moment";
import moment from 'moment-timezone'
import Vuex from 'vuex'
import vuetify from "@/plugins/vuetify";
import VueTheMask from 'vue-the-mask'
import "./plugins/base";


//seta locale para pt-br;
moment.locale('pt-br');
moment.tz.setDefault("America/Sao_Paulo");

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(vueFilters);
Vue.use(VueMoment, {
    moment
});
Vue.use(VueTheMask)

Vue.use(Vuex)



new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");